import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { nimmAnmeldeZiel } from "@/lib/auth/anmeldeZiel";
import { useAuth } from "@/lib/auth/AuthContext";

// Supabase tauscht den OAuth-Code asynchron gegen eine Session (detectSessionInUrl).
// Bis das SIGNED_IN-Event feuert, meldet der Context kurz signed-out — daher
// Grace-Period, sonst springt der Browser zu frueh auf /login zurueck.
const REDIRECT_GRACE_MS = 5000;

export function AuthCallbackPage() {
  const { status } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === "signed-in") {
      // TAGESMAIL-1: zurueck auf die Stelle, die vor der Anmeldung verlangt
      // war (z.B. ein Link aus der Morgenmail) — sonst die Startseite.
      void navigate(nimmAnmeldeZiel() ?? "/", { replace: true });
      return;
    }
    if (status === "signed-out") {
      const t = setTimeout(() => {
        void navigate("/login", { replace: true });
      }, REDIRECT_GRACE_MS);
      return () => {
        clearTimeout(t);
      };
    }
    return;
  }, [status, navigate]);

  return (
    <main className="flex min-h-full items-center justify-center p-8">
      <p className="text-sm text-muted-foreground">Anmeldung wird abgeschlossen...</p>
    </main>
  );
}
